import { useRef } from 'react';
import { Box } from '@mui/material';

// A count on a results table that opens the leads behind it. A zero is plain text (nothing to open). Resting the pointer
// on it (or focusing it with the keyboard) starts loading the leads, so the popup is usually ready when it is clicked.
const PREFETCH_DELAY_MS = 120; // ignores a pointer just passing over a column of numbers

const CountLink = ({ count, label, onOpen, onPrefetch }) => {
  const timer = useRef(null);
  const number = Number(count) || 0;
  if (number === 0) return <span>{number}</span>;

  const warm = () => {
    clearTimeout(timer.current);
    timer.current = setTimeout(() => onPrefetch && onPrefetch(), PREFETCH_DELAY_MS);
  };
  const cool = () => clearTimeout(timer.current);

  return (
    <Box
      component="button"
      type="button"
      onClick={onOpen}
      onMouseEnter={warm}
      onMouseLeave={cool}
      onFocus={warm}
      onBlur={cool}
      aria-label={`Show the ${number} ${label}`}
      title={`Show the ${label}`}
      sx={{
        font: 'inherit',
        fontVariantNumeric: 'tabular-nums',
        color: '#4A3190',
        background: 'none',
        border: 0,
        borderBottom: '1px dotted #4A3190',
        p: 0,
        cursor: 'pointer',
        '&:hover, &:focus-visible': { color: '#2F1E6B', borderBottomStyle: 'solid', outline: 'none' },
        '&:focus-visible': { boxShadow: '0 0 0 2px #CFC3EE', borderRadius: '2px' },
      }}
    >
      {number}
    </Box>
  );
};

export default CountLink;
